import {createContext} from "react";

export const isAuthenticatedContext = createContext();

export const userInfosContext = createContext();